//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { DISTRIBUTION_ENDPOINTS } from '@apis/content-library/contentLibraryApiModel';

import { IContentItemDetails } from 'app/bulk-actions/model/AppState';

export const isSyndicatedItem = (item: IContentItemDetails): boolean =>
  item.distributionEndpoints.includes(DISTRIBUTION_ENDPOINTS.connect);
